import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import type { UnifiedRow } from "@/components/organisms/RecommendationsSection/adapters/toUnifiedRow";
import {
  formatUnifiedDate,
  kindClass,
  kindLabel,
} from "@/components/organisms/RecommendationsSection/adapters/toUnifiedRow";

interface EntityCardProps {
  row: UnifiedRow;
  onClick: (row: UnifiedRow) => void;
}

export function EntityCard({ row, onClick }: EntityCardProps) {
  return (
    <div
      className="flex h-full cursor-pointer flex-col gap-2 rounded-md border p-3 hover:shadow-md transition-shadow"
      onClick={() => onClick(row)}
    >
      <div className="flex items-start justify-between gap-2">
        <Badge
          variant="outline"
          className={cn("text-xs py-0 px-1.5 shrink-0", kindClass[row.kind])}
        >
          {kindLabel[row.kind]}
        </Badge>
        {row.score !== null && (
          <Badge className="text-xs py-0 px-2">{row.score}</Badge>
        )}
      </div>

      <h3 className="text-sm font-medium truncate" title={row.title}>
        {row.title}
      </h3>
      <p
        className="text-xs text-muted-foreground truncate"
        title={row.path}
      >
        {row.path}
      </p>

      <div className="mt-auto flex items-center justify-between gap-2 pt-2">
        {row.status !== "-" ? (
          <Badge
            variant="outline"
            className={cn("text-xs py-0 px-1.5", row.statusTone)}
          >
            {row.status}
          </Badge>
        ) : (
          <span />
        )}
        <span className="text-xs text-muted-foreground">
          {formatUnifiedDate(row.date as Date | { toDate?: () => Date } | null | undefined)}
        </span>
      </div>
    </div>
  );
}
